// Theme: supernova-prism
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'supernova-prism',
  name: 'SUPERNOVA PRISM',
  tagline: 'SUPERNOVA PRISM',
  description: 'Estrutura Supernova com paleta magenta prismatica.',
  category: 'cosmic-scale',
  tier: 'epic',
  basePrice: 3675,
  swatches: ['#1A0C19', '#2A1528', '#F0ABFC', '#FDF4FF'],
  familyId: 'supernova',
  variantName: 'PRISM',
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '12px',
      '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
      '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)'
    },
    shellClasses: 'font-mono theme-supernova-prism'
  },
  colorVars: {
    '--accent': '#F0ABFC',
    '--accent-foreground': '#1A0C19',
    '--background': '#1A0C19',
    '--border': '#7A2A8A',
    '--card': '#2A1528',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FDF4FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0C19',
    '--foreground': '#FDF4FF',
    '--hold-fill': '#F0ABFC',
    '--input': '#7A2A8A',
    '--modal-bg': '#1A0C19',
    '--modal-border': '#7A2A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#7A2A8A',
    '--muted-foreground': '#FDF4FF',
    '--nav-active': '#F0ABFC',
    '--nav-bg': '#2A1528',
    '--popover': '#2A1528',
    '--popover-foreground': '#FDF4FF',
    '--primary': '#F0ABFC',
    '--primary-foreground': '#1A0C19',
    '--ring': '#F0ABFC',
    '--secondary': '#7A2A8A',
    '--secondary-foreground': '#FDF4FF',
    '--streak': '#F0ABFC',
    '--success': '#22c55e',
    '--success-foreground': '#1A0C19',
    '--xp': '#F0ABFC',
    '--xp-bg': '#2A1528'
  },
  resolvedVars: {
    '--accent': '#F0ABFC',
    '--accent-foreground': '#1A0C19',
    '--accent-foreground-hsl': '304 37% 7%',
    '--accent-foreground-oklch': 'from #1A0C19 l c h',
    '--accent-hsl': '291 93% 83%',
    '--accent-oklch': 'from #F0ABFC l c h',
    '--background': '#1A0C19',
    '--background-hsl': '304 37% 7%',
    '--background-oklch': 'from #1A0C19 l c h',
    '--border': '#7A2A8A',
    '--border-hsl': '290 53% 35%',
    '--border-oklch': 'from #7A2A8A l c h',
    '--border-w': '1px',
    '--card': '#2A1528',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#FDF4FF',
    '--card-foreground-hsl': '289 100% 98%',
    '--card-foreground-oklch': 'from #FDF4FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 10%, transparent)',
    '--card-hsl': '306 33% 12%',
    '--card-oklch': 'from #2A1528 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#1A0C19',
    '--destructive-foreground-hsl': '304 37% 7%',
    '--destructive-foreground-oklch': 'from #1A0C19 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#FDF4FF',
    '--foreground-hsl': '289 100% 98%',
    '--foreground-oklch': 'from #FDF4FF l c h',
    '--hold-fill': '#F0ABFC',
    '--hold-fill-hsl': '291 93% 83%',
    '--hold-fill-oklch': 'from #F0ABFC l c h',
    '--input': '#7A2A8A',
    '--input-hsl': '290 53% 35%',
    '--input-oklch': 'from #7A2A8A l c h',
    '--modal-bg': '#1A0C19',
    '--modal-bg-hsl': '304 37% 7%',
    '--modal-bg-oklch': 'from #1A0C19 l c h',
    '--modal-border': '#7A2A8A',
    '--modal-border-hsl': '290 53% 35%',
    '--modal-border-oklch': 'from #7A2A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--muted': '#7A2A8A',
    '--muted-foreground': '#FDF4FF',
    '--muted-foreground-hsl': '289 100% 98%',
    '--muted-foreground-oklch': 'from #FDF4FF l c h',
    '--muted-hsl': '290 53% 35%',
    '--muted-oklch': 'from #7A2A8A l c h',
    '--nav-active': '#F0ABFC',
    '--nav-active-hsl': '291 93% 83%',
    '--nav-active-oklch': 'from #F0ABFC l c h',
    '--nav-bg': '#2A1528',
    '--nav-bg-hsl': '306 33% 12%',
    '--nav-bg-oklch': 'from #2A1528 l c h',
    '--popover': '#2A1528',
    '--popover-foreground': '#FDF4FF',
    '--popover-foreground-hsl': '289 100% 98%',
    '--popover-foreground-oklch': 'from #FDF4FF l c h',
    '--popover-hsl': '306 33% 12%',
    '--popover-oklch': 'from #2A1528 l c h',
    '--primary': '#F0ABFC',
    '--primary-foreground': '#1A0C19',
    '--primary-foreground-hsl': '304 37% 7%',
    '--primary-foreground-oklch': 'from #1A0C19 l c h',
    '--primary-hsl': '291 93% 83%',
    '--primary-oklch': 'from #F0ABFC l c h',
    '--radius': '12px',
    '--ring': '#F0ABFC',
    '--ring-hsl': '291 93% 83%',
    '--ring-oklch': 'from #F0ABFC l c h',
    '--secondary': '#7A2A8A',
    '--secondary-foreground': '#FDF4FF',
    '--secondary-foreground-hsl': '289 100% 98%',
    '--secondary-foreground-oklch': 'from #FDF4FF l c h',
    '--secondary-hsl': '290 53% 35%',
    '--secondary-oklch': 'from #7A2A8A l c h',
    '--shadow-card': '0 12px 30px rgba(0, 0, 0, 0.26)',
    '--shadow-card-active': '0 0 22px color-mix(in srgb, var(--primary) 50%, transparent)',
    '--streak': '#F0ABFC',
    '--streak-hsl': '291 93% 83%',
    '--streak-oklch': 'from #F0ABFC l c h',
    '--success': '#22c55e',
    '--success-foreground': '#1A0C19',
    '--success-foreground-hsl': '304 37% 7%',
    '--success-foreground-oklch': 'from #1A0C19 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(291 93% 83% / 0.15)',
    '--xp': '#F0ABFC',
    '--xp-bg': '#2A1528',
    '--xp-bg-hsl': '306 33% 12%',
    '--xp-bg-oklch': 'from #2A1528 l c h',
    '--xp-hsl': '291 93% 83%',
    '--xp-oklch': 'from #F0ABFC l c h'
  }
}
